<template>
  <v-container fluid class="px-15 pb-10 pt-4">
    <!-- Regresar -->
    <div style="position: absolute;">
      <v-btn @click="$router.go(-1)" text class="pl-0">
        <v-icon class="mr-1" size="15px">mdi-arrow-left</v-icon>
        <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">Regresar</span>
      </v-btn>
    </div>

    <!-- Título -->
    <v-row class="ma-0 mt-5 mb-4">
      <v-col class="pa-0 my-4">
        <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">
          {{ empresa.sName ?  empresa.sName + ' - ' + empresa.tipoOnboarding : '' }}
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Cumplimiento KYC: <strong>{{ empresa ? empresa.porcentajeCumplimiento : 0 }}%</strong>
        </div>
      </v-col>
    </v-row>

    <!-- Botón Configurar -->
    <v-row class="mb-4">
      <v-col cols="12" class="d-flex justify-end align-center" style="gap: 12px;">
        <v-chip v-if="empresa.estatusOnboarding === 'aprobado'" color="green" dark>
          <v-icon left small>mdi-check-circle</v-icon>
          Aprobada
        </v-chip>
        <v-btn
          v-else
          color="black"
          dark
          rounded
          :disabled="!todosRequeridosAprobados || !empresa.enterpriseProductId"
          :loading="isAprobando"
          @click="dialogConfirmarAprobacion = true"
        >
          <v-icon left small>mdi-check</v-icon>
          Aprobar empresa
        </v-btn>
        <v-btn color="black" dark rounded @click="dialogAsignar = true, getKycDocuments(), documentosSeleccionados = []">
          Configurar documentos
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla documentos KYC -->
    <v-data-table :items="documentos" class="d-none d-sm-block" hide-default-header>
      <template v-slot:header>
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">Nombre</th>
            <th class="header__title center">Categoría</th>
            <th class="header__title center">Descripción</th>
            <th class="header__title center">Requerido</th>
            <th class="header__title center">Tipo de Entrada</th>
            <th class="header__title center">Estatus</th>
            <th class="header__title center">Valor actual</th>
            <th class="header__title right">Acciones</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.nombre }}</td>
            <td class="table__item">{{ item.categoria }}</td>
            <td class="table__item">{{ item.descripcion }}</td>
            <td class="table__item">{{ item.es_requerido ? 'Sí' : 'No' }}</td>
            <td class="table__item">{{ item.tipo_input }}</td>
            <td class="table__item">
              <v-chip :color="getColor(item.estatus)" dark>{{ item.estatus }}</v-chip>
            </td>
            <td class="table__item">
              <template v-if="getCurrentInput(item)">
                <span v-if="getCurrentInput(item).input_type === 'text'">{{ getCurrentInput(item).value_text }}</span>
                <span v-else>{{ getCurrentInput(item).file_name }}</span>
              </template>
              <span v-else class="grey--text">—</span>
            </td>
            <td class="table__item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="black" v-bind="attrs" v-on="on" @click="abrirUpload(item)" :disabled="empresa.estatusOnboarding === 'aprobado'">
                    <v-icon>mdi-upload</v-icon>
                  </v-btn>
                </template>
                <span>Cargar documento</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="black" v-bind="attrs" v-on="on" @click="abrirEditor(item)" :disabled="empresa.estatusOnboarding === 'aprobado'">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar status</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="black" v-bind="attrs" v-on="on" @click="abrirHistorial(item)">
                    <v-icon>mdi-history</v-icon>
                  </v-btn>
                </template>
                <span>Ver historial</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="red" v-bind="attrs" v-on="on" @click="eliminarDocumento(item)" :disabled="empresa.estatusOnboarding === 'aprobado'">
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar documento</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <!-- Dialog asignar documentos -->
    <v-dialog v-model="dialogAsignar" max-width="900px">
      <v-card class="pa-4" style="border-radius: 24px">
        <v-card-title class="text-h6 font-weight-bold">Asignar documentos KYC</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="documentosDisponibles"
            item-key="sId"
            style="background-color: #ffffff !important;"
            show-select
            v-model="documentosSeleccionados"
          >
            <template v-slot:item.ejemplo_path="{ item }">
              <v-btn v-if="item.ejemplo_path" icon @click="verEjemplo(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
              <span v-else class="grey--text text--lighten-1">-</span>
            </template>
            <template v-slot:item.es_requerido="{ item }">
              <v-chip center small outlined :color="item.es_requerido ? 'green' : 'grey'">
                {{ item.es_requerido ? 'Sí' : 'No' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text class="px-4" rounded @click="dialogAsignar = false">Cancelar</v-btn>
          <v-btn color="black" dark rounded class="px-4" :disabled="documentosSeleccionados.length === 0" :loading="loading" @click="assignDocumentToOnboarding()">Asignar seleccionados</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog cargar documento -->
    <v-dialog v-model="dialogUpload" v-if="dialogUpload" max-width="600px" persistent>
      <v-card class="pa-4" style="border-radius: 24px;">
        <v-card-title class="font-weight-bold text-h6">
          {{ documentoUpload && documentoUpload.tipo_input === 'text' ? 'Capturar información' : 'Cargar documento' }}
        </v-card-title>
        <v-card-subtitle v-if="documentoUpload" class="mt-1">
          {{ documentoUpload.nombre }} — {{ documentoUpload.categoria }}
        </v-card-subtitle>
        <v-card-text class="pt-4">
          <!-- Input tipo texto -->
          <v-textarea
            v-if="documentoUpload && documentoUpload.tipo_input === 'text'"
            v-model="textoInput"
            :label="documentoUpload.nombre"
            :hint="documentoUpload.descripcion"
            persistent-hint
            outlined
            rows="4"
          />
          <!-- Input tipo archivo -->
          <v-file-input
            v-else
            v-model="archivosSeleccionados"
            label="Seleccionar archivos"
            outlined
            dense
            multiple
            show-size
            accept=".pdf,.jpg,.jpeg,.png,.cer,.key,.pfx,.p12,.pem,.xml"
            prepend-icon="mdi-paperclip"
            hint="Formatos permitidos: PDF, JPG, PNG, CER, KEY, PFX, PEM, XML"
            persistent-hint
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text rounded :disabled="isUploading" @click="closeUploadDialog()">Cancelar</v-btn>
          <v-btn
            color="black" dark rounded
            :disabled="isUploading || !isUploadFormValid"
            :loading="isUploading"
            @click="guardarInput()"
          >
            {{ documentoUpload && documentoUpload.tipo_input === 'text' ? 'Guardar' : 'Subir' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog editar estatus -->
    <v-dialog v-model="dialogEditar" max-width="600px">
      <v-card class="pa-4">
        <v-card-title class="font-weight-bold text-h6">Actualizar estatus del documento</v-card-title>
        <v-card-text>
          <v-select
            v-model="formEditar.estatus"
            :items="estatusOptions"
            item-text="label"
            item-value="value"
            label="Estatus"
            dense
            outlined
          />
          <v-textarea v-model="formEditar.comentario" label="Comentario del admin" rows="2" outlined dense />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text :disabled="loading" @click="dialogEditar = false">Cancelar</v-btn>
          <v-btn color="black" dark :loading="loading" :disabled="loading" @click="guardarCambios">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog confirmar aprobación -->
    <v-dialog v-model="dialogConfirmarAprobacion" max-width="500px">
      <v-card class="pa-4" style="border-radius: 24px;">
        <v-card-title class="font-weight-bold text-h6">
          Confirmar aprobación
        </v-card-title>
        <v-card-text class="pt-2">
          ¿Desea aprobar la empresa <strong>{{ empresa.sName }}</strong> para el producto <strong>{{ empresa.tipoOnboarding }}</strong>?
          <br>
          Esta acción habilitará el producto para la empresa.
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text rounded :disabled="isAprobando" @click="dialogConfirmarAprobacion = false">
            Cancelar
          </v-btn>
          <v-btn color="black" dark rounded :loading="isAprobando" :disabled="isAprobando" @click="aprobarEmpresa()">
            Aprobar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog eliminar documento -->
    <v-dialog v-model="modalEliminate" max-width="500px">
      <v-card class="pa-4" style="border-radius: 24px;">
        <v-card-title class="font-weight-bold text-h6">Confirmar eliminación</v-card-title>
        <v-card-text class="pt-2">
          ¿Desea eliminar el documento <strong>{{ documentoEliminar?.nombre }}</strong>?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text rounded :disabled="isEliminando" @click="modalEliminate = false">Cancelar</v-btn>
          <v-btn color="red" dark rounded :loading="isEliminando" @click="eliminarDocumentoConfirmado()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog historial -->
    <v-dialog v-model="dialogHistorial" max-width="700px">
      <v-card class="pa-4" style="border-radius: 24px;">
        <v-card-title class="font-weight-bold text-h6">Información cargada</v-card-title>
        <v-card-subtitle v-if="documentoHistorial" class="mt-1">
          {{ documentoHistorial.nombre }} — {{ documentoHistorial.categoria }}
        </v-card-subtitle>
        <v-card-text>
          <div v-if="historialActual.length === 0" class="text-center grey--text py-4">
            No hay información cargada para este documento.
          </div>
          <v-list dense v-else>
            <v-list-item v-for="(archivo, i) in historialActual" :key="i">
              <v-list-item-icon>
                <v-icon>{{ getInputIcon(archivo) }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <template v-if="archivo.input_type === 'text'">{{ archivo.value_text }}</template>
                  <template v-else>{{ archivo.file_name }}</template>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ formatDate(archivo.created_at) }}
                  <v-chip x-small class="ml-2" :color="archivo.source === 'admin' ? 'blue' : 'green'" dark>
                    {{ archivo.source === 'admin' ? 'Admin' : 'Empresa' }}
                  </v-chip>
                  <span v-if="archivo.file_size" class="ml-2 grey--text">{{ (archivo.file_size / 1024).toFixed(0) }} KB</span>
                  <v-chip v-if="archivo.is_current" x-small class="ml-2" color="orange" dark>Actual</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="archivo.input_type !== 'text'">
                <v-btn icon @click="verArchivo(archivo)">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text rounded @click="dialogHistorial = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      empresa: {},
      dialogAsignar: false,
      dialogEditar: false,
      loading: false,
      dialogHistorial: false,
      documentosSeleccionados: [],
      documentoActual: null,
      formEditar: {
        estatus: '',
        comentario: ''
      },
      estatusOptions: [
        { label: 'Pendiente', value: 'pendiente' },
        { label: 'En revisión', value: 'en_revision' },
        { label: 'Aprobado', value: 'aprobado' },
        { label: 'Rechazado', value: 'rechazado' },
      ],
      documentos: [],
      dialogUpload: false,
      todosRequeridosAprobados: false,
      modalEliminate: false,
      documentoEliminar: null,
      isEliminando: false,
      isUploading: false,
      documentoUpload: null,
      archivosSeleccionados: [],
      textoInput: '',
      dialogConfirmarAprobacion: false,
      isAprobando: false,
      documentoHistorial: null,
      historialActual: [],
      documentosDisponibles: [],
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Categoría', value: 'categoria' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Tipo', value: 'tipo_input' },
        { text: 'Requerido', value: 'es_requerido' },
        { text: 'Ejemplo', value: 'ejemplo_path', sortable: false }
      ]
    };
  },
  computed: {
    // todosRequeridosAprobados() {
    //   const requeridos = this.documentos.filter(d => d.requerido || d.es_requerido);
    //   return requeridos.length > 0 && requeridos.every(d => d.estatus === 'aprobado');
    // },
    isUploadFormValid() {
      if (!this.documentoUpload) return false;
      if (this.documentoUpload.tipo_input === 'text') {
        return !!this.textoInput.trim();
      }
      return this.archivosSeleccionados && this.archivosSeleccionados.length > 0;
    },
  },
  mounted() {
    this.getDocuments();
  },
  methods: {
    aprobarEmpresa() {
      this.isAprobando = true;

      DB.put(`${URI}/api/v1/en/administrator/enterprise-product/${this.empresa.enterpriseProductId}/toggle`, {}, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.mixSuccess(response.data.message || 'Empresa aprobada correctamente');
        this.dialogConfirmarAprobacion = false;
        this.getDocuments();
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isAprobando = false;
      });
    },
    getDocuments() {
      this.loading = true;

      DB.get(`${URI}/api/v1/en/administrator/onboarding/empresa/${this.$route.params.empresaId}?producto=${encodeURIComponent(this.$route.params.producto)}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.documentos = response.data.documentos || [];
        this.empresa = response.data.empresa || {};
        console.log('Datos de empresa:', this.empresa);
        this.todosRequeridosAprobados = response.data.empresa.porcentajeCumplimiento === 100 ? true : false;
        console.log('Estatus de onboarding:', this.estatusOnboarding);
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getKycDocuments() {
      this.loading = true;

      DB.get(`${URI}/api/v1/en/administrator/getKycDocuments?flujo=${this.empresa.product_type || this.$route.params.producto}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        const disponibles = response.data.documents;
        const asignadosIds = new Set(this.documentos.map(d => d.kyc_document_id || d.sId));
        this.documentosDisponibles = disponibles.filter(d => !asignadosIds.has(d.sId));
        this.documentosSeleccionados = [];
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    assignDocumentToOnboarding() {
      if (this.documentosSeleccionados.length === 0) {
        this.mixError('Seleccione al menos un documento para asignar.', 400);
        return;
      }

      const payload = {
        documents: this.documentosSeleccionados.map(doc => ({
          empresa_id: this.$route.params.empresaId,
          kyc_document_id: doc.sId,
          flujo: this.empresa.product_type || this.$route.params.producto,
          estatus: 'pendiente'
        }))
      };

      this.loading = true;

      DB.post(`${URI}/api/v1/en/administrator/onboarding/empresa/${this.$route.params.empresaId}/assign`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then(() => {
        this.getDocuments();
        this.dialogAsignar = false;
        this.documentosSeleccionados = [];
        this.mixSuccess('Documentos asignados correctamente.');
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    eliminarDocumento(item) {
      this.documentoEliminar = item;
      this.modalEliminate = true;
    },
    eliminarDocumentoConfirmado(item){
      if (!this.documentoEliminar) return;

      this.isEliminando = true;
      DB.delete(`${URI}/api/v1/en/administrator/onboarding/documento/${this.documentoEliminar.document_empresa_id}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then(() => {
        this.mixSuccess('Documento eliminado correctamente');
        this.getDocuments();
        this.modalEliminate = false;
        this.documentoEliminar = null;
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isEliminando = false;
      });
     
    },
    abrirUpload(item) {
      this.documentoUpload = item;
      this.archivosSeleccionados = [];
      const currentInput = this.getCurrentInput(item);
      this.textoInput = (currentInput && currentInput.input_type === 'text') ? currentInput.value_text || '' : '';
      this.dialogUpload = true;
    },
    closeUploadDialog() {
      this.dialogUpload = false;
      this.documentoUpload = null;
      this.archivosSeleccionados = [];
      this.textoInput = '';
    },
    guardarInput() {
      if (!this.documentoUpload) return;
      if (this.documentoUpload.tipo_input === 'text') {
        this.guardarTexto();
      } else {
        this.subirArchivos();
      }
    },
    subirArchivos() {
      if (!this.archivosSeleccionados.length) return;

      this.isUploading = true;
      const formData = new FormData();
      this.archivosSeleccionados.forEach((file) => {
        formData.append('archivos', file);
      });

      DB.post(
        `${URI}/api/v1/en/administrator/onboarding/documento/${this.documentoUpload.document_empresa_id}/upload`,
        formData,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((response) => {
        this.mixSuccess(response.data.message);
        this.closeUploadDialog();
        this.getDocuments();
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isUploading = false;
      });
    },
    guardarTexto() {
      if (!this.textoInput.trim()) return;

      this.isUploading = true;
      DB.post(
        `${URI}/api/v1/en/administrator/onboarding/documento/${this.documentoUpload.document_empresa_id}/text`,
        { value_text: this.textoInput },
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
      .then((response) => {
        this.mixSuccess(response.data.message);
        this.closeUploadDialog();
        this.getDocuments();
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isUploading = false;
      });
    },
    getCurrentInput(item) {
      if (!item.inputs || !item.inputs.length) return null;
      return item.inputs.find(i => i.is_current) || item.inputs[0];
    },
    getInputIcon(archivo) {
      if (archivo.input_type === 'text') return 'mdi-text-box';
      if (!archivo.file_type) return 'mdi-file';
      if (archivo.file_type.includes('pdf')) return 'mdi-file-pdf-box';
      if (archivo.file_type.includes('image')) return 'mdi-file-image';
      if (archivo.file_name && /\.(cer|key|pfx|pem|p12)$/i.test(archivo.file_name)) return 'mdi-certificate';
      if (archivo.file_name && /\.xml$/i.test(archivo.file_name)) return 'mdi-file-xml-box';
      return 'mdi-file';
    },
    getColor(estatus) {
      switch (estatus) {
        case 'aprobado': return 'green';
        case 'en_revision': return 'blue';
        case 'pendiente': return 'grey';
        case 'rechazado': return 'red';
        default: return 'grey';
      }
    },
    abrirHistorial(item) {
      this.documentoHistorial = item;
      this.historialActual = item.inputs || [];
      this.dialogHistorial = true;
    },
    verEjemplo(item) {
      alert(`Ver ejemplo: ${item.ejemplo_path || 'Sin ejemplo disponible'}`);
    },
    asignarSeleccionados() {
      this.documentosSeleccionados.forEach(doc => {
        const yaExiste = this.documentos.some(d => d.nombre === doc.nombre);
        if (!yaExiste) {
          this.documentos.push({
            id: doc.sId,
            nombre: doc.nombre,
            categoria: doc.categoria,
            descripcion: doc.descripcion,
            requerido: doc.es_requerido,
            estatus: 'pendiente',
            archivos: 0
          });
        }
      });
      this.dialogAsignar = false;
      this.documentosSeleccionados = [];
    },
    abrirEditor(doc) {
      this.documentoActual = doc;
      this.formEditar.estatus = doc.estatus;
      this.formEditar.comentario = doc.comentario_admin || '';
      this.dialogEditar = true;
    },
    guardarCambios() {
      if (!this.documentoActual) return;

      this.loading = true;
      DB.put(`${URI}/api/v1/en/administrator/onboarding/documento/${this.documentoActual.document_empresa_id}/estatus`, {
        estatus: this.formEditar.estatus,
        comentario_admin: this.formEditar.comentario,
      }, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then(() => {
        this.mixSuccess('Estatus actualizado correctamente');
        this.dialogEditar = false;
        this.getDocuments();
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    verArchivo(archivo) {
      if (archivo.signed_url) {
        window.open(archivo.signed_url, '_blank');
      }
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
      return formattedDate;
    },
  }
};
</script>

<style scoped>
</style>
